import { useContext, useEffect, useState } from "react";
import { Filter } from "../Filter/Filter";
import classes from "./ProductList.module.scss"
import TestImage from '../../../../assets/sample-image.png'
import { ProductCard } from "../../../../components/ProductCard/ProductCard";
import { ProductService } from "../../../../services/ProductService";
import { START_LOADER, STOP_LOADER } from "../../../../constants";
import { useLoader } from "../../../../customHooks/loader";
import { globalErrorHandler } from "../../../../utils/errorHandler";

export const ProductsList = () => {
    const PRODUCTS_PER_PAGE = 12;
    const defaultFilters = {
        categories: ["Abaya A", "Abaya B", "Abaya C", "Abaya D", "Joggers", "Shirt"],
        price: {
            min: 0,
            max: 1000
        },
        colors: ['#0048BA',
            '#B0BF1A',
            '#7CB9E8',
            '#C9FFE5',
            '#B284BE',
            '#5D8AA8',
            '#00308F',
            '#72A0C1',
            '#AF002A',
            '#F2F0E6',
            '#F0F8FF',
            '#84DE02',
            '#E32636',
            '#C46210',
            '#EFDECD',
            '#E52B50',
            '#9F2B68',
            '#F19CBB',
            '#AB274F',
            '#D3212D',
            '#3B7A57',
            '#00C4B0',
            '#FFBF00',
            '#FF7E00',
            '#FF033E',
            '#9966CC',
            '#A4C639',
            '#F2F3F4',
            '#CD9575',
            '#665D1E',
            '#915C83',
            '#841B2D',
            '#FAEBD7',
            '#008000',
            '#8DB600',
            '#FBCEB1',
            '#00FFFF',
            '#7FFFD4',
            '#D0FF14',
            '#4B5320',
            '#3B444B',
            '#8F9779',
            '#E9D66B',
            '#B2BEB5',
            '#87A96B',
            '#FF9966',
            '#A52A2A',
            '#FDEE00',
            '#6E7F80',
            '#568203',
            '#FF2052',
            '#C39953',
            '#007FFF',
            '#F0FFFF',
            '#F0FFFF',
            '#DBE9F4',
            '#89CFF0',
            '#A1CAF1',
            '#F4C2C2',
            '#FEFEFA',
            '#FF91AF',
            '#21ABCD'
        ],
        size: ["S", "M", "L", "XXL", "XXXL"],
        dressStyle: ["Abaya A", "Abaya B", "Abaya C", "Abaya D", "Joggers", "Shirt"],
        scarf: ["in", "out"],
        abayaCut: ["abayaCut-1", "abayaCut-2", "abayaCut-3"],
        abayaMaterial: ["abayaMaterial-1", "abayaMaterial-2", "abayaMaterial-3"],

    };
    const [filters, setFilters] = useState({
        category: '',
        price: {
            min: 0,
            max: 1000
        },
        colors: ["red"],
        size: [],
        dressStyle: '',
        scarf: [],
        abayaCut: '',
        abayaMaterial: ''
    });

    const [product, setProduct] = useState([]);
    const [page, setPage] = useState(0);
    const loader = useLoader();

    useEffect(() => {
        getProductList()
    }, [page])

    const getProductList = () => {
        ProductService.getProductList(
            {},
            page,
            handleGetProductListSuccess,
            globalErrorHandler,
            loader,
            PRODUCTS_PER_PAGE,
        )
    }

    const handleGetProductListSuccess = ({ data }) => {
        console.log({ data });
        setProduct(data.data.products);
    }

    const wishlistOnClick = (id) => {
        let newList = product.map(item => ({
            ...item,
            addedToWishilist: item.id === id ? !item.addedToWishilist : item.addedToWishilist
        }))

        setProduct(newList);
    }

    const [level1Category, setLevel1Category] = useState('new')
    return (
        <div className={classes.productPage}>
            <div className={classes.FilterAndProducts}>
                <Filter defaultFilters={defaultFilters} filters={filters} setFilters={setFilters} />
                <div className={classes.RightSection}>
                    <div className={classes.heading}>
                        <div className={classes.leftHeading}>&nbsp;</div>
                        <div className={classes.RightHeading}>
                            <div
                                className={`${level1Category === 'new' ? classes.RightHeadingActive : ''}`}
                                onClick={() => setLevel1Category('new')}
                            >New</div>
                            <div
                                className={`${level1Category !== 'new' ? classes.RightHeadingActive : ''}`}
                                onClick={() => setLevel1Category('recommended')}
                            > Recommended</div>
                        </div>
                    </div>

                    <div className={classes.products}>
                        {product.length ? product.slice(page * PRODUCTS_PER_PAGE, page * PRODUCTS_PER_PAGE + PRODUCTS_PER_PAGE).map((item) => {
                            return (
                                <ProductCard
                                    itemDetails={item}
                                    showWishlistButton
                                    wishlist={item.addedToWishilist}
                                    wishlistOnClick={wishlistOnClick}
                                />
                            )
                        }) : null}
                    </div>
                    {product.length > PRODUCTS_PER_PAGE ? <div className={classes.PageControl}>
                        <button className={`${classes.NextButton} ${page * PRODUCTS_PER_PAGE + PRODUCTS_PER_PAGE <= product.length ? "" : classes.NextButtonDisabled}`} onClick={() => {
                            if (page * PRODUCTS_PER_PAGE + PRODUCTS_PER_PAGE <= product.length) setPage(page + 1)
                        }}>Next &gt;</button>
                        <button className={`${classes.NextButton} ${page === 0 ? classes.NextButtonDisabled : ""}`} onClick={() => {
                            if (page > 0) setPage(page - 1)
                        }}>&lt; Back</button>
                    </div> : null}

                </div>
            </div>
        </div >
    )
}